import { c as _c } from "react/compiler-runtime";
import * as Popover from '@radix-ui/react-popover';

// Owns the Radix Popover lifecycle. The TipTap Suggestion plugin re-renders
// this with fresh props on every keystroke — Radix handles flip / collision /
// portal positioning so we don't reimplement it.
type SuggestionPopoverProps = {
  rect: DOMRect | null;
  children: React.ReactNode;
  /** Sit beside the caret rather than below it, so a hint reads as typed-in placeholder text. */
  inline?: boolean;
};
const SuggestionPopover = t0 => {
  const $ = _c(14);
  const {
    rect,
    children,
    inline: t1
  } = t0;
  const inline = t1 === undefined ? false : t1;
  if (!rect) {
    return null;
  }
  const t2 = rect.width || 1;
  const t3 = rect.height || 1;
  let t4;
  if ($[0] !== rect.left || $[1] !== rect.top || $[2] !== t2 || $[3] !== t3) {
    t4 = <Popover.Anchor style={{
      position: "fixed",
      top: rect.top,
      left: rect.left,
      width: t2,
      height: t3,
      pointerEvents: "none"
    }} />;
    $[0] = rect.left;
    $[1] = rect.top;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = inline ? "right" : "bottom";
  const t6 = inline ? "center" : "start";
  const t7 = inline ? 1 : 4;
  const t8 = !inline;
  let t9;
  if ($[5] !== children || $[6] !== t5 || $[7] !== t6 || $[8] !== t7 || $[9] !== t8) {
    t9 = <Popover.Portal><Popover.Content data-mention-popup={true} side={t5} align={t6} sideOffset={t7} collisionPadding={8} avoidCollisions={t8} onOpenAutoFocus={_temp} onCloseAutoFocus={_temp2} className="z-50">{children}</Popover.Content></Popover.Portal>;
    $[5] = children;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t4 || $[12] !== t9) {
    t10 = <Popover.Root open={true}>{t4}{t9}</Popover.Root>;
    $[11] = t4;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
};
export default SuggestionPopover;
function _temp(e) {
  return e.preventDefault();
}
function _temp2(e_0) {
  return e_0.preventDefault();
}